import { useFormikContext } from 'formik';
import React from 'react';

import type { SlateCreativeInputV5 } from '../../../../apis/graphql';
import AssetImporterField from '../../../../common/Form/AssetImporterField';
import { assetTypes } from '../../../../configs';
import type { AdFormValues } from '../../adFormik';
import { isCreativeAssetRemoveForbidden } from '../../utils/creative';
import { CreativeFooter } from '../components';
import CreativeBuilder from '../CreativeBuilder';
import type { CreativeBuilderProps } from '../CreativeBuilder/CreativeBuilder';
import { useCreativeData } from '../hooks/useCreativeData';
import type { CreativesBuilderValues } from '../types';

export const constructSlateCreativeInput = ({
  name,
  slate,
  creativeLibraryId,
}: CreativesBuilderValues): SlateCreativeInputV5 => {
  const input: SlateCreativeInputV5 = { name, type: 'SLATE' };
  if (slate?.id !== '') input.slateId = slate?.id;
  if (creativeLibraryId) input.creativeLibraryId = creativeLibraryId;

  return input;
};

function SlateCreativeBuilder({ isPreview, adTypeDimensions, editMode }: CreativeBuilderProps): React.JSX.Element {
  const { values: adFormValues } = useFormikContext<AdFormValues>();
  const { creative, lineItem } = adFormValues;

  const {
    data: { assets },
  } = useCreativeData(creative, lineItem?.displayPublisherTarget);

  const assetReadonly = isCreativeAssetRemoveForbidden(editMode, creative);

  return (
    <CreativeBuilder
      lineItemPublishers={lineItem?.displayPublisherTarget || []}
      lineItemCountry={lineItem?.country}
      classNameModifier="slate"
      isPreview={isPreview}
      editMode={editMode}
    >
      <AssetImporterField
        adTypeDimensions={adTypeDimensions?.video}
        id="asset-uploader"
        formFieldName="creative.slate"
        assetType={assetTypes.VideoAsset.key}
        label="Slate Asset"
        aspectRatio={16 / 9}
        isPreview={isPreview}
        readonly={assetReadonly}
        lineItemCountry={lineItem?.country}
        lineItemPublisherList={lineItem?.displayPublisherTarget || []}
      />
      <CreativeFooter assets={assets} creative={creative} lineItemData={lineItem} />
    </CreativeBuilder>
  );
}

export default SlateCreativeBuilder;
